import { render, staticRenderFns } from "./DialogAddQuestion.vue?vue&type=template&id=3dcba25e"
import script from "./DialogAddQuestion.vue?vue&type=script&lang=js"
export * from "./DialogAddQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports